export const getOrder = (alias: string): number | null => {
  const n = parseInt(alias, 10);

  return Number.isNaN(n) ? null : n;
};

export const trimPhoneValue = (phone?: PhoneValueType | null): string =>
  `${phone?.countryCode ?? ''}${phone?.areaCode ?? ''}${phone?.phoneNumber ?? ''}`.replace(/\D/g, '').trim();

export const trimValue = (value?: unknown) => {
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();

  return trimmed === '' ? undefined : trimmed;
};

export const getDate = (date: string, formatType?: string): string => {
  if (date) {
    const parsedDate = new Date(date);
    const options: Intl.DateTimeFormatOptions =
      formatType === 'DATE_AND_TIME'
        ? {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }
        : { day: '2-digit', month: '2-digit', year: 'numeric' };

    return new Intl.DateTimeFormat('en-GB', options)?.format(parsedDate);
  } else {
    return '';
  }
};

export const getFileFormat = (fname) => {
  return fname?.slice((Math.max(0, fname?.lastIndexOf('.')) || Infinity) + 1);
};

export const getNameOfItem = (field: string, t: (key: string, options: { ns: string[] }) => string) => {
  let result = field?.match?.(/(lessons)\[(.+)\]\.(exercises)\[(.+)\]/);

  if (result && result[1] === 'lessons' && result[3] === 'exercises') {
    field = `${t('text.lesson')} ${parseInt(result[2]) + 1} ${t('text.exercise', {
      ns: ['text'],
    })} ${parseInt(result[4]) + 1}`;
  }

  if (!result) {
    result = field?.match?.(/(lessons)\[(.+)\]/);
    if (result && result[1] === 'lessons') {
      field = `${t('test.lesson')} ${parseInt(result[2]) + 1}`;
    }
  }

  return field?.title;
};

export const removeBase = (html) => html.replace(/(<[^>/]*head[^>]*>)[\s\S]*?(<[^>]*head[^>]*>)/gim, '');

export const getUrl = ({
  link,
  alias,
  courseCategoryAlias,
  lessonAlias,
  getParams,
}: {
  link: string;
  alias?: string;
  courseCategoryAlias?: string;
  lessonAlias?: string;
  getParams?: string;
}): string | undefined => {
  let uri = link;

  if (alias) {
    uri = uri.replace(/:alias/gi, alias);
  }

  if (courseCategoryAlias) {
    uri = uri.replace(/:courseCategoryAlias/gi, courseCategoryAlias);
  }

  if (lessonAlias) {
    uri = uri.replace(/:lessonAlias/gi, lessonAlias);
  }

  if (getParams) {
    uri += getParams;
  }

  return uri;
};

export const generateRandomHexId = (size = 24) =>
  [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');

export const capitalize = (s: string) => s[0].toUpperCase() + s.slice(1);

export const parseQueryString = () => {
  const objURL = {};
  if (typeof window !== 'undefined') {
    const str = window.location.search;

    str.replace(/([^?=&]+)(=([^&]*))?/g, ($0: string, $1: string, $2: string, $3: string) => {
      objURL[$1] = $3;

      return $0;
    });
  }

  return objURL;
};

export const capitalizeFirstLetter = (val) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
};

const uuidv4 = () =>
  Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(0, 24);
